import { graphql } from '@api/mesa'

export const JOIN_WAITLIST = graphql(`
  mutation JoinWaitlist {
    joinWaitlist {
      status
      message
    }
  }
`)

export const VERIFY_CARD_INVITE_CODE = graphql(`
  mutation verifyCardInviteCode($verifyCardInviteCode: VerifyCardInviteCodeRequestDto!) {
    verifyCardInviteCode(verifyCardInviteCode: $verifyCardInviteCode) {
      verificationSuccessful
      verificationCodeType
    }
  }
`)

export const GENERATE_STATEMENT_PDF_LINK = graphql(`
  mutation GenerateStatementPdfLink($statementId: String!) {
    generateStatementPdfLink(input: { statementId: $statementId }) {
      url
    }
  }
`)

export const ACTIVATE_PAYMENT_CARD = graphql(`
  mutation ActivatePaymentCard {
    activatePaymentCard
  }
`)

export const REDEEM_POINTS_FOR_STATEMENT_CREDIT = graphql(`
  mutation RedeemPointsForStatementCredit($numPoints: Int!, $idempotencyKey: String!) {
    redeemPointsForStatementCredit(
      redeemPointsForStatementCreditRequestDto: {
        numPoints: $numPoints
        idempotencyKey: $idempotencyKey
      }
    )
  }
`)

export const ADD_PAYMENT_TO_APPLE_PAY = graphql(`
  mutation addPaymentCardToApplePayByDevicePushProvisioning(
    $input: ApplePayPushProvisioningRequestDto!
  ) {
    addPaymentCardToApplePayByDevicePushProvisioning(input: $input) {
      encryptedPassData
      activationData
      ephemeralPublicKey
    }
  }
`)
